import eventBus from '@/utils/eventBus'
import store from '@/store'

export function getEditContent(h, data, node) {
  let self = this
  return (
    <span class="ly-visible">
      <el-button
        size="mini"
        type="text"
        on-click={(e) => {
          e.stopPropagation();
          self.close(data, node, e);
        }}
      >
        ✘
      </el-button>
      <el-button
        size="mini"
        type="text"
        on-click={(e) => {
          e.stopPropagation();
          self.editMsg(data, node, e);
        }}
      >
        ✔
      </el-button>
    </span>
  )
}

export function getDefaultContent(h, data, node) {
  let self = this;
  // if(data["level"] == 4){}
  if(data['IsLeaf'] != undefined && data['IsLeaf']==true && data["level"] != null){
    this.$store.state.projectarealevel = data["level"];
  }

  return (
    <div class="ly-visible">
      {
        self.issuper == true ?
          (<span class="tree_button">
            {/* {
              data.id !== 0 && data.level !== -1 && data.isShowUp && <el-button
                size="mini"
                type="text"
                icon="el-icon-download el-icon-tree-top"
                on-click={() => self.rowTop(node, data)}
              >
              </el-button>
            }
            {
              data.id !== 0 && data.level !== -1 && data.isShowUp && <el-button
                size="mini"
                type="text"
                icon="el-icon-top"
                on-click={() => self.rowUp(node, data)}
              >
              </el-button>
            }
            {
               data.id !== 0 && data.level !== -1 && data.isShowDown && <el-button
                size="mini"
                type="text"
                icon="el-icon-bottom"               
                on-click={() => self.rowDown(node, data)}
              >
              </el-button>
            } */}
            {
              data.id !== 0 && data.level !== -1 && data.UpdateArea &&
              <el-button
                size="mini"
                type="text"
                icon=" el-icon-edit"
                on-click={(e) => {
                  e.stopPropagation();
                  self.update(node, data, e);
                }}
              >

              </el-button>
            }
            {
               data.level == -1 && data.name !== '无区域' && data.AddArea && store.state.isNoLimit &&
               <div>
                <img class = "upload" src={require('@/assets/img/icon/upload.png')}
                on-click={(e) => { 
                    self.uploadAreaTreeExcel(node, data); 
                    e.stopPropagation();
                    eventBus.$emit("switchRightComponent")
                  }
                }
                ></img>
               </div>
            }
            {
              data.level == -1 && data.name !== '无区域' && data.AddArea &&
              <el-button class="leve_add"
                size="mini"
                type="text"
                icon=" el-icon-plus"
                on-click={(e) => {
                  e.stopPropagation();
                  self.append(node, data, e);
                }}
              >

              </el-button>

            }

            {
              // data.level !== 4 && data.id !== 0&& data.level !== -1 &&data.AddArea&&
              // 最大层级没有添加区域图标
              ((data['IsLeaf'] == undefined && data.level !== self.$store.state.projectarealevel) || (data['IsLeaf'] != undefined && data['IsLeaf'] != true)) && data.id !== 0 && data.level !== -1 && data.AddArea &&
              <el-button
                size="mini"
                type="text"
                icon=" el-icon-plus"
                on-click={(e) => {
                  e.stopPropagation();
                  self.append(node, data, e);
                }}
              >

              </el-button>

            }

            {

              data.id !== 0 && data.level !== -1 && !data.child && data.DeleteArea &&
              <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                on-click={(e) => {
                  e.stopPropagation();
                  self.remove(node, data, e);
                }}
              >

              </el-button>
            }
          </span>)
          : ''
        // :(self.is_switch == true && <span>
        //   {
        //   data.id !== 0 && data.level !== -1&&
        //   <button
        //       size="mini"
        //       class="switchCss"
        //       name="switch"
        //       on-click={ (e) => self.switch(node, data, e) }
        //     >

        //       {
        //       (self.gpno == data.id)?<div style="width:100%;height:100%;background-position: 50%;
        //       background-image: url('/static/img/checkboxYes.png');
        //       background-repeat: no-repeat;"></div>:(data.switch==true?<div style="width:100%;height:100%;background-position: 50%;
        //       background-image: url('/static/img/checkboxYes.png');
        //       background-repeat: no-repeat;"></div>:<div style="width:100%;height:100%;background-position: 50%;
        //       background-image: url('/static/img/checkboxNo.png');
        //       background-repeat: no-repeat;"></div>)
        //       // (self.gpno == data.id)?self.switchYes:(data.switch==true?self.switchYes:self.switchNo)
        //       }
        //     </button>
        //   }
        // </span>)
      }
    </div>
  )
}
